import { Category } from "../generated/gql/graphql";

export type Flatten = {
  id: string | number;
  status?: string;
  parent_id?: number | string;
  order_index?: number | null | undefined;
  name?: string;
  children?: any;
};

export type FlattenV2 = {
  id: string | number;
  parentId?: number | string;
  name?: string;
};

type SupportateFlattenTypes = Category[] | any[];

export function flattenV2(categories: SupportateFlattenTypes): Flatten[] {
  // Note(john): Implementation for the graphql type version
  return flatten(
    categories.map((v) => ({
      id: v.id,
      parent_id: v.parentId || undefined,
      name: v.name || undefined,
      order_index: v.orderIndex || undefined,
      children: [],
    }))
  );
}

export const flatten = (Nodes: Flatten[]): Flatten[] => {
  if (!Nodes || Nodes.length === 0) {
    return [];
  }

  const map: any = {};
  const roots: Flatten[] = [];
  let node: Flatten;
  let i: number;

  for (i = 0; i < Nodes.length; i += 1) {
    map[Nodes[i].id] = i;
    Nodes[i].children = [];
  }

  for (i = 0; i < Nodes.length; i += 1) {
    node = Nodes[i];

    if (node.parent_id && node.parent_id !== 0) {
      Nodes[map[node.parent_id]].children.push(node);
    } else {
      roots.push(node);
    }
  }

  return roots;
};
